import ThisModule from "./ModalMenu";

export default ThisModule;
